export const project_list_enums = {
  PROJECT_IMAGE: 'project_image',
  PROJECT_TITLE: 'project_title',
  PROJECT_DESCRIPTION: 'project_description',
  PROJECT_DATE: 'project_date',
  // PROJECT_TEAM: 'project_team',
  PROJECT_ACTION: 'project_action',
};
